import React from 'react';
import styled from 'styled-components';
import { FaFacebookF } from 'react-icons/fa';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const Section = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const BgImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('/images/sunflower.jpg');
  background-size: cover;
  background-position: center;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
`;

const Card = styled.div`
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  padding: 60px 50px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);

  @media (max-width: 600px) {
    padding: 40px 25px;
  }
`;

const Title = styled.h2`
  font-size: 2.2rem;
  color: var(--earth);
  margin-bottom: 35px;
  text-align: center;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 22px;

  svg {
    color: var(--barn-red);
    font-size: 1.2rem;
    margin-top: 3px;
    flex-shrink: 0;
  }
`;

const InfoText = styled.div`
  font-size: 1.05rem;
  color: var(--earth);
  font-weight: 500;
  line-height: 1.5;

  a {
    color: var(--earth);
    transition: color 0.3s ease;

    &:hover {
      color: var(--barn-red);
    }
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(139, 35, 35, 0.12);
  margin: 25px 0;
`;

const SocialRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--barn-red);
  color: var(--wheat);
  font-size: 1.2rem;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(139, 35, 35, 0.4);
  }
`;

const MapContainer = styled.div`
  margin-top: 25px;
  border-radius: 12px;
  overflow: hidden;
  height: 180px;
  border: 2px solid rgba(139, 35, 35, 0.1);

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export default function Contact() {
  return (
    <Section id="contact">
      <BgImage />
      <Overlay />

      <Card>
        <Title>Contact Us</Title>

        <InfoRow>
          <FiMapPin />
          <InfoText>
            8939 Williston Rd<br />
            Williston, VT 05495
          </InfoText>
        </InfoRow>

        <InfoRow>
          <FiPhone />
          <InfoText>
            <a href="tel:8022330429">(802) 233-0429</a>
          </InfoText>
        </InfoRow>

        <InfoRow>
          <FiMail />
          <InfoText>
            <a href="mailto:redbarngardensvt@gmail.com">redbarngardensvt@gmail.com</a>
          </InfoText>
        </InfoRow>

        <Divider />

        <SocialRow>
          <SocialLink
            href="https://www.facebook.com/RedBarnGardens"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </SocialLink>
        </SocialRow>

        <MapContainer>
          <iframe
            title="Red Barn Gardens Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2846.5!2d-73.0767!3d44.4283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cca7a3b3b3b3b3b%3A0x0!2s8939+Williston+Rd%2C+Williston%2C+VT+05495!5e0!3m2!1sen!2sus!4v1"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </MapContainer>
      </Card>
    </Section>
  );
}
